
import CountryDropdown from "components/dropdowns/reactselect/CountryDropdown";
import StateDropdown from "components/dropdowns/reactselect/StateDropdown";
import { InnerFormTemplate } from "components/MainSectionTemplate/InnerFormTemplate";
import OptionalTextInput from "components/ValidatedFields/OptionalTextInput";
import React from "react";
import { Address } from "shared/utils/fieldsHelper/companyFields";
import { EditNewSectionField } from "components/MainSectionTemplate/types";


interface Props {
  address: Address
  onChange: (value: Address) => void;
  submit: () => void;
  isSaving: boolean;
  fields?: EditNewSectionField[]
  fieldsBottom?: EditNewSectionField[]
}

export const AddressInnerForm = (props: Props) => {
  return <InnerFormTemplate
    submit={props.submit}
    isSaving={props.isSaving}
    section={{
      key: "address",
      title: "",
      type: "regular",
      fields: [
        ...(props.fields ?? []),
        {
          key: "addressLine1",
          label: RESX.Address.AddressLine + " 1",
          renderEditNew: () => (
            <OptionalTextInput
              focusOnMount={!props.fields}
              maxLength={serverReference.constants.address.maxAddressLineLength}
              value={props.address.addressLine1}
              onChange={(value) => props.onChange({
                ...props.address,
                addressLine1: value
              })}
            />
          )
        }, {
          key: "addressLine2",
          label: RESX.Address.AddressLine + " 2",
          renderEditNew: () => (
            <OptionalTextInput
              maxLength={serverReference.constants.address.maxAddressLineLength}
              value={props.address.addressLine2}
              onChange={(value) => props.onChange({
                ...props.address,
                addressLine2: value
              })}
            />
          )
        }, {
          key: "postalCode",
          label: RESX.Address.PostalCode,
          renderEditNew: () => (
            <OptionalTextInput
              maxLength={serverReference.constants.address.maxPostalCodeLength}
              value={props.address.postalCode}
              onChange={(value) => props.onChange({
                ...props.address,
                postalCode: value
              })}
            />
          )
        }, {
          key: "city",
          label: RESX.Address.City,
          renderEditNew: () => (
            <OptionalTextInput
              maxLength={serverReference.constants.address.maxCityLength}
              value={props.address.city}
              onChange={(value) => props.onChange({
                ...props.address,
                city: value
              })}
            />
          )
        }, {
          key: "country",
          label: RESX.Address.Country,
          renderEditNew: () => (
            <CountryDropdown
              value={props.address.country}
              onChange={(value) => props.onChange({
                ...props.address,
                country: value,
                state: value.states.find(s => s.isCountryDefault)
              })}
            />
          )
        }, {
          key: "state",
          label: RESX.Address.State,
          renderEditNew: () => (
            <StateDropdown
              value={props.address.state}
              options={props.address.country?.states ?? []}
              onChange={(value) => props.onChange({
                ...props.address,
                state: value
              })}
            />
          )
        },
        ...(props.fieldsBottom ?? []),
      ],
    }}
  />
}